module.exports = __webpack_public_path__ + "img/back2.0043e970.png";